"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var NotAuthenticated = function () { return (React.createElement("div", { className: "oidc-not-authenticated" },
    React.createElement("div", { className: "oidc-not-authenticated__container" },
        React.createElement("h1", { className: "oidc-not-authenticated__title" }, "Authentification"),
        React.createElement("p", { className: "oidc-not-authenticated__content" }, "Vous n'\u00EAtes pas authentifi\u00E9.")))); };
exports.default = NotAuthenticated;
